<template>
  <div
    :class="['list_one', 'icon-combination-wrapper', 'list-one-style-'+listArr.module_style]"
    :key="i"
    data-comb-dom
    :data-col_num="infor.col_num[infor.col_num.radio_val].value"
  >
    <div
      :class="['module-content', pc_infor.shadowVisible==='true'?'module-content-shadow':'','module-content-style-'+listArr.module_style]"
      :style="{...backgroundStyle,...paddingStyle,...getBoxShadowStyle(item)}"
      @mouseenter="onMouseEnter(item)"
      @mouseleave="onMouseLeave(item)">
      <div
        :class="['list_img_frame', 'animationBox', 'icon-combination-box', `icon-combination-${listArr.iconAlign}`]"
        ref="animationBox">
        <div class="icon-wrapper"
             :style="{width:infor.img_size[infor.img_size.radio_val].widthPercent+'%',borderRadius:pc_infor.borderRadius[pc_infor.borderRadius.radio_val].value+'px',...iconBackground}">
          <img class="img-icon" :src="item.img_path" :alt="item.title"
               :style="{borderRadius:pc_infor.borderRadius[pc_infor.borderRadius.radio_val].value+'px'}">
          <div
            class="tooptipPart img-tooltip"
            v-if="$store.state.app.view_pattern === 'pc' && item.img_type == 'custom'"
            @click.stop
          >
            <my_hover_btn :tips="$t('widgets_basic_icon_combination_components_one_icon_591')" btnIcon="el-icon-edit" @changeStyle="edit_one"></my_hover_btn>
          </div>
        </div>
        <div class="text-wrapper" :style="{...textWrapperStyle}">
          <div class="icon-combination-title" :style="{...titleFontStyle}" v-html="title"></div>
          <div class="icon-combination-summary" v-if="infor.alt_display==='true'" :style="{...summaryFontStyle}"
               v-html="item.summary"></div>
        </div>
        <set_link class="linkPart" :sendData="item.intro"></set_link>
        <div
          class="tooptipPart one-icon-tooptip"
          v-if="$store.state.app.view_pattern === 'pc' && item.img_type == 'custom'"
          @click.stop
        >
          <my_edit_btn :module="module" tabName="style" coverClick @click.native="onClickEditBtn"></my_edit_btn>
          <my_hover_btn :tips="$t('widgets_basic_picture_text_swiper_components_one_picture_2726')" btnIcon="el-icon-close" @changeStyle="del_one"></my_hover_btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "basic_picture_text_swiper_one_picture",
  components: {},
  props: {
    module: {
      type: Object,
      default: null
    },
    pc_infor: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    i: {
      type: Number,
      default: 0
    },
    infor: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: "ordinary"
    },
    imgs: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    img_effects() {
      return this.module.data.img_effects;
    },
    listArr() {
      return this.module.data.listArr
    },
    titleFontStyle() {
      return this.$utils.getFontStyle(this.pc_infor.titleFont, this)
    },
    summaryFontStyle() {
      return this.$utils.getFontStyle(this.pc_infor.summaryFont, this)
    },
    backgroundStyle() {
      return this.$utils.getBackgroundStyle(this.pc_infor)
    },
    paddingStyle() {
      let info = this.pc_infor.padding
      if (info.radio_val !== 'default') {
        let paddingTop = info.custom.paddingTop
        let paddingLeft = info.custom.paddingLeft
        if (!String(paddingTop).endsWith('%') && !String(paddingTop).endsWith('px')) {
          paddingTop = paddingTop + '%'
        }
        if (Number(this.listArr.module_style) === 1) {
          paddingTop = '20px'
        }
        if (!String(paddingLeft).endsWith('%') && !String(paddingLeft).endsWith('px')) {
          paddingLeft = paddingLeft + '%'
        }
        return {
          padding: paddingTop + ' ' + paddingLeft
        }
      } else {
        let defaultPaddingTop = Number(this.listArr.module_style) === 1 ? '20px' : info.default.paddingTop
        console.log('info.default.paddingLeft:', info.default.paddingLeft)
        return {
          padding: defaultPaddingTop + ' ' + info.default.paddingLeft
        }
      }
    },
    textWrapperStyle() {
      let style = {}
      if (Number(this.listArr.module_style) === 1) {
        let infor = this.infor
        style.width = (100 - infor.img_size[infor.img_size.radio_val].widthPercent) + '%'
      }
      return style
    },
    iconBackground() {
      let infor = this.pc_infor
      return {
        backgroundColor: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.color : infor.icon_background.default.color,
        backgroundImage: infor.icon_background.radio_val == 'custom' && infor.icon_background.custom.img !== '' ? 'url(' + infor.icon_background.custom.img + ')' : '',
        backgroundSize: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.background_size : '',
        backgroundRepeat: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.background_repeat : '',
        backgroundPosition: infor.icon_background.radio_val == 'custom' ? infor.icon_background.custom.background_position : ''
      }
    },
    title() {
      return this.item.title
    }
  },
  methods: {
    onClickEditBtn() {
      this.$store.commit("app/changeModuleSelectItemId", this.item.album_id);
      this.templet.changeStyle(this.module, 'style');
    },
    edit_one() {
      this.$store.commit("image_upload/set_fileType", 1);
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          this.item.img_path = e[0].filePath;
        }

        this.$store.state.image_upload.imgFile = null;
      };
    },
    del_one() {
      if (this.imgs.length <= 1) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_basic_icon_combination_components_circle_layout_589')
        });
        return;
      }
      this.$confirm(i18n.t('widgets_basic_icon_combination_components_circle_layout_590'), "", {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true
      }).then(() => {
        this.imgs.splice(this.i, 1);
      })
        .catch(() => {
        });
    },
    getBoxShadowStyle(item) {
      if (item.isHover) {
        return this.$utils.getBoxShadowStyle(this.pc_infor.boxShadow, 'hover')
      } else {
        return this.$utils.getBoxShadowStyle(this.pc_infor.boxShadow)
      }
    },
    onMouseEnter(item) {
      this.$set(item, 'isHover', true)
    },
    onMouseLeave(item) {
      this.$set(item, 'isHover', false)
    }
  },
  created() {
  },
  mounted() {
    this.templet.initImageAnimation(
      this.img_effects,
      this.img_effects,
      this.$refs.animationBox,
      this.$store.state.app.view_pattern
    );
  }
};
</script>

<style scoped lang="scss">
.basic_picture_text_swiper {
  .list_one {
    position: relative;
    width: 100%;
    height: 100%;

    .tooptipPart {
      right: 0;
      bottom: 0;
      top: auto;
      display: none;
      z-index: 999;
    }

    .list_img_frame {
      position: relative;
      overflow: hidden;

      .list_img_back {
        width: 60px;
        height: 60px;
        position: absolute;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        background-position: center center;
        -webkit-transition: all ease 0.36s;
        -o-transition: all ease 0.36s;
        -moz-transition: all ease 0.36s;
        transition: all ease 0.36s;
        background-repeat: no-repeat;
      }
    }
  }

  .list_one:hover .tooptipPart {
    display: block;
  }
}

.module-content {
  height: 100%;
  padding: 15%;
}

.icon-wrapper {
  display: inline-block;
  width: 25%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.img-icon {
  max-width: 100%;
}

.icon-combination-title {
  font-size: 16px;
  color: #333;
  margin-top: 20px;
  line-height: 1.3;
  word-break:normal;
}

.icon-combination-summary {
  font-size: 14px;
  color: #999;
  margin-top: 12px;
  line-height: 1.3;
  word-break:normal;
}

.one-icon-tooptip {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.img-tooltip {
  top: 0 !important;
  display: none !important;
}

.icon-wrapper:hover {
  .img-tooltip {
    display: block !important;
  }
}


.module-content-style-0 {

  .icon-combination-default {
    text-align: center;
  }

  .icon-combination-center {
    text-align: center;
  }

  .icon-combination-left {
    text-align: left;
  }

  .icon-combination-right {
    text-align: right;
  }
}

.module-content-style-1 {
  display: flex;

  .icon-combination-summary {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.module-content-style-1 .icon-combination-box {
  display: flex;
  align-items: center;
}

.module-content-style-1 .icon-wrapper {
  text-align: center;
  flex: 1 1;

  .img-icon {
    max-height: 100%;
    width: 100%;
    object-fit: cover;
  }
}

.module-content-style-1 {
  .text-wrapper {
    width: 75%;
    padding-left: 15px;
    text-align: left;
  }

  .icon-combination-top {
    align-items: flex-start;

    .icon-combination-title {
      margin-top: -0.2em;
    }
  }

  .icon-combination-bottom {
    align-items: flex-end;

    .icon-combination-summary {
      margin-bottom: -0.2em;
    }
  }
}


.module-content-style-1 .icon-combination-title {
  margin-top: 0;
}

.module-content-style-2 {
  background: #f2f2f2;

  .icon-wrapper {
    display: inline-block;
  }
}

.module-content-style-2 {
  padding: 12.5% 15.6%;

  .icon-combination-title {
    margin-top: 24px;
  }

  .icon-combination-summary {
    margin-top: 10px;
  }

  .icon-combination-default {
    text-align: left;
  }

  .icon-combination-left {
    text-align: left;
  }

  .icon-combination-center {
    text-align: center;
  }

  .icon-combination-right {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_picture_text_swiper/components/one_picture.vue